module.exports = __webpack_public_path__ + "static/media/bootstrap.7321a5c4.png";